import { Box, BoxProps } from "@mui/material";

// Propsの型定義（sxを受け取れるようにする）
interface LogoProps {
  sx?: BoxProps["sx"];
}

const Logo = ({ sx }: LogoProps) => {
  return (
    // ▼ width: 120 は元のコードの指定を維持しています
    // 正方形のロゴなので、height も合わせておくとレイアウトが安定します
    <Box sx={{ width: 300, height: 300, ...sx }}>
      <img
        src="/assets/icons/empty/Pink and Blue Cupcake Icon Food Logo.svg"
        alt="Logo"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain" // 縦横比を崩さずに枠に収める
        }}
      />
    </Box>
  );
};

export default Logo;